export default __webpack_public_path__ + "static/media/hinted-subset-Roboto-Medium.52cb737b.woff";